import { Analysis, PossibleRootCauseCategory } from '.';

export class PlateletsAnalysis extends Analysis {
    calculateInsights() {
        if (this.ba.platelets.isGreaterThanOptimal()) {
            this.possibleRootCauseCategories.push(PossibleRootCauseCategory.CATEGORY_5000);
        } else if (this.ba.platelets.isStricklyLessThanOptimal()) {
            this.possibleRootCauseCategories.push(PossibleRootCauseCategory.CATEGORY_5010);
        }

        if (this.ba.mpv.isGreaterThanOptimal()) {
            this.possibleRootCauseCategories.push(PossibleRootCauseCategory.CATEGORY_5020);
        } else if (this.ba.mpv.isStricklyLessThanOptimal()) {
            this.possibleRootCauseCategories.push(PossibleRootCauseCategory.CATEGORY_5030);
        }

        if (this.ba.dDimer.isGreaterThanOptimal()) {
            this.possibleRootCauseCategories.push(PossibleRootCauseCategory.CATEGORY_5040);
        }

        if (this.ba.fibrinogen.isGreaterThanOptimal()) {
            this.possibleRootCauseCategories.push(PossibleRootCauseCategory.CATEGORY_5060);
        } else if (this.ba.fibrinogen.isStricklyLessThanOptimal()) {
            this.possibleRootCauseCategories.push(PossibleRootCauseCategory.CATEGORY_5070);
        }

        if (this.ba.viscosityCapiliaries.isGreaterThanOptimal()) {
            this.possibleRootCauseCategories.push(PossibleRootCauseCategory.CATEGORY_5075);
        } else if (this.ba.viscosityCapiliaries.isStricklyLessThanOptimal()) {
            this.possibleRootCauseCategories.push(PossibleRootCauseCategory.CATEGORY_5080);
        }
    }
}